import * as React from "react";
import { css } from "@emotion/react";
import { backgroundColor } from "main/javascripts/styles/base/colorStyle";

interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  backgroundStyleKey?: keyof IBackgroundStyle;
}

export const MainBlock: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { backgroundStyleKey = "primary", children, ...rest } = props;
  return (
    <div css={[blockStyle, backgroundStyle[backgroundStyleKey]]} {...rest}>
      {children}
    </div>
  );
};

export interface IBackgroundStyle {
  primary: any;
  secondary: any;
}

const blockStyle = css`
  box-sizing: border-box;
`;

const backgroundStyle: IBackgroundStyle = {
  primary: css``,
  secondary: css`
    background-color: ${backgroundColor.secondaryLightColor};
  `,
};
